import { d as concatAll, c as compact, m as map, w as fromNullable, h as chain, z as getMonoid } from '../Either-48abb652.js';
import { p as pipe } from '../ReadonlyNonEmptyArray-0e481d0b.js';
import { Node_Type } from 'ricos-schema';
import { RICOS_NODE_TYPE_TO_DATA_FIELD } from '../consts.js';
import { extract } from './extract.js';
import '../extractor-infra.js';
import '../index-a60c253d.js';
import '../ReadonlyRecord-86a56753.js';
import '../string-40bcd6bf.js';

const getText = (content) => {
  var _a;
  return extract((_a = content.nodes) != null ? _a : []).map(({ textData }) => (textData == null ? void 0 : textData.text) || "").get();
};
const getPluginData = (content, type) => {
  var _a;
  return extract((_a = content.nodes) != null ? _a : []).map((node) => node[RICOS_NODE_TYPE_TO_DATA_FIELD[type]]).get();
};
const MediaM = getMonoid();
const getMedia = (content) => concatAll(MediaM)([
  pipe(
    getPluginData(content, Node_Type.IMAGE),
    map(({ image }) => image),
    map(fromNullable),
    compact
  ),
  pipe(
    getPluginData(content, Node_Type.VIDEO),
    map(({ video }) => video),
    map(fromNullable),
    compact
  ),
  pipe(
    getPluginData(content, Node_Type.GALLERY),
    chain(({ items }) => items),
    map(({ image, video }) => (image == null ? void 0 : image.media) || (video == null ? void 0 : video.media)),
    map(fromNullable),
    compact
  )
]);

export { getMedia, getPluginData, getText };
//# sourceMappingURL=extract-by-type.js.map
